import { render, staticRenderFns } from "./UseStatisManage.vue?vue&type=template&id=1bbb9fca&"
import script from "./UseStatisManage.vue?vue&type=script&lang=js&"
export * from "./UseStatisManage.vue?vue&type=script&lang=js&"
import style0 from "./UseStatisManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports